import { ApiContext } from '../../types'
import { AuthHelper } from '@/api_client'
import { deserializeAudio } from '../serializers/audio'

export default async function removeFolders(
  { client, config }: ApiContext,
  folderIds: number[],
  isPermanent: boolean,
) {
  const response = await client.folders.remove(
    AuthHelper.getAccessToken(),
    folderIds,
    isPermanent,
  )
  if (response.isSuccess()) {
    const success = response.success()
    return true
  } else {
    console.log('getUsers: fail')
    throw response.fail()
  }
}
